import { render, staticRenderFns } from "./NotificationLaboratoriesApprovalRequest.vue?vue&type=template&id=32d8fce0"
import script from "./NotificationLaboratoriesApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationLaboratoriesApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports